var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "vue2-dropzone",
    {
      ref: "dropzone",
      attrs: {
        id: "dropzone",
        options: _vm.dropzoneOptions,
        useCustomSlot: "",
      },
      on: {
        "vdropzone-sending": _vm.sendingEvent,
        "vdropzone-success": _vm.fileSuccess,
        "vdropzone-complete": _vm.fileCompleted,
        "vdropzone-files-added": _vm.filesAdded,
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isUploading,
              expression: "!isUploading",
            },
          ],
          staticClass: "dz-dropzone p-1",
          attrs: { id: "documentDropZone" },
        },
        [_vm._v("Excel zum Upload hierhin ziehen")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }